import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import { CITY_REGEX } from 'common-constants/validation';
import { TextField } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';

const InputAddressCity = ({ prefill }) => {
  const { control } = useFormContext();
  return (
    <ValidatedTextField
      name="city"
      control={control}
      defaultValue={prefill}
      rules={{
        required: 'This field is required.',
        pattern: {
          value: CITY_REGEX,
          message: 'Please enter a valid city.',
        },
      }}
    >
      <TextField fullWidth label="City" />
    </ValidatedTextField>
  );
};

export default InputAddressCity;
